import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LoadingStatus } from 'GeminiViewerComponent/helpers/AsyncStatus';
import {
    fetchAppConfigValues,
    selectConfigValuesApp,
    selectConfigValuesAppLoadingStatus,
    selectConfigValuesAppLoadedAssetId,
    selectConfigValuesAppLoadedClientId,
    selectConfigValuesAppForDisplay,
} from 'features/configValues/configValuesSlice';
import { useConfigFields } from './useConfigFields';

export function useConfigValues({ clientId, assetId }) {
    const dispatch = useDispatch();

    const {
        validationTypesLoadingStatus,
        configFieldsLoadingStatus,
        configFields,
        validationTypes,
        validationRawTypes,
    } = useConfigFields();

    const configValuesLoadingStatus = useSelector(selectConfigValuesAppLoadingStatus);
    let configValues = useSelector((state) => selectConfigValuesAppForDisplay(state, clientId, assetId, configFields));
    const configLoadedAssetId = useSelector(selectConfigValuesAppLoadedAssetId);
    const configLoadedClientId = useSelector(selectConfigValuesAppLoadedClientId);
    const selectedConfigValues = useSelector(selectConfigValuesApp);

    useEffect(() => {
        const fetchConfigValues = async () => {
            if (clientId !== configLoadedClientId || assetId !== configLoadedAssetId || !selectedConfigValues) {
                // dispatch(
                //     setConfigLoadedAssetClient({
                //         assetId: assetId,
                //         clientId: clientId,
                //     })
                // );
                return await dispatch(fetchAppConfigValues({ clientId, assetId }));
            }
        };

        if (
            validationTypesLoadingStatus === LoadingStatus.Loaded &&
            configFieldsLoadingStatus === LoadingStatus.Loaded
        ) {
            fetchConfigValues();
        }
    }, [
        validationTypesLoadingStatus,
        configFieldsLoadingStatus,
        clientId,
        assetId,
        configLoadedClientId,
        configLoadedAssetId,
        dispatch,
        selectedConfigValues,
    ]);

    return {
        configValuesLoadingStatus,
        configFieldsLoadingStatus,
        validationTypesLoadingStatus,
        configValues,
        configFields,
        validationTypes,
        validationRawTypes,
    };
}
